/* ============================================================
   PDP — Delegated Photoswipe trigger.

   Por qué existe:
   El theme reemplaza el <a class="product-gallery__media-link">
   cuando el usuario clickea un thumbnail (swap de imagen
   principal). zoom.js bindea el click handler de Photoswipe en
   los <a> ORIGINALES al inicio (connectedCallback), así que el
   <a> nuevo NO tiene el handler — el browser navega al href de
   la imagen en lugar de abrir el modal.

   Fix: delegar el click handler sobre el slider parent (que NO
   se reemplaza). Cuando un click llega a algún
   [data-zoom-wrapper] dentro del slider, llamamos a la misma
   lógica de zoom.js (construir items + LoadPhotoswipe).

   Capture: true → corremos ANTES que el navegador siga el href.
   ============================================================ */
(function () {
  'use strict';

  function initDelegate(slider) {
    if (slider.dataset.sofsZoomDelegated === '1') return;
    slider.dataset.sofsZoomDelegated = '1';

    slider.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('[data-zoom-wrapper]');
        if (!link || !slider.contains(link)) return;
        if (slider.classList.contains('is-moving')) return;
        if (!window.theme || !window.theme.LoadPhotoswipe) return;

        // Read current href/dimensions LIVE (post-swap)
        var wrappers = slider.querySelectorAll('[data-zoom-wrapper]');
        if (!wrappers.length) return;

        var items = [];
        var triggerIndex = 0;
        Array.prototype.forEach.call(wrappers, function (w, i) {
          items.push({
            src: w.getAttribute('href'),
            w: parseInt(w.getAttribute('data-image-width'), 10),
            h: parseInt(w.getAttribute('data-image-height'), 10),
            msrc: w.getAttribute('href'),
          });
          if (w === link) triggerIndex = i;
        });

        var mainClass = items.length === 1
          ? 'pswp-zoom-gallery pswp-zoom-gallery--single'
          : 'pswp-zoom-gallery';

        var options = {
          barsSize: { top: 60, bottom: 60 },
          history: false,
          focus: false,
          index: triggerIndex,
          mainClass: mainClass,
          showHideOpacity: true,
          showAnimationDuration: 250,
          hideAnimationDuration: 250,
          closeOnScroll: false,
          closeOnVerticalDrag: false,
          captionEl: false,
          closeEl: true,
          closeElClasses: ['caption-close'],
          tapToClose: false,
          clickToCloseNonZoomable: false,
          maxSpreadZoom: 2,
          loop: true,
          spacing: 0,
          allowPanToNext: true,
          pinchToClose: false,
        };

        event.preventDefault();
        event.stopPropagation();

        new window.theme.LoadPhotoswipe(items, options, 0, link);
      },
      true
    );
  }

  function run() {
    var sliders = document.querySelectorAll('[data-product-single-media-slider]');
    Array.prototype.forEach.call(sliders, initDelegate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Re-run in case the slider is injected later (variant change, AJAX, etc.)
  setTimeout(run, 800);
  setTimeout(run, 2000);
})();
